<template lang="html">
    <div>
        <template>
            <p>Êtes-vous sûr de vouloir supprimer cette information ?</p>
			<p><strong>{{ params.feature.label }}</strong></p>
        </template>

    </div>
</template>

<script>
    export default {
        props: {
            params: {
                required: true
            }
        },

        data() {
            return {
                title:          'Supression d\'une information',
                icon:           'delete',
                warning:        true
            }
        },

        methods: {
            onClose() {
                this.$eventHub.$emit('close-modal')
            },

            onValidate() {
                this.axios.delete(`/api/features/${this.params.feature.id}`)
                    .then(response => {
                        this.$eventHub.$emit('close-modal')
                        this.$eventHub.$emit('reload-single')
                    })
                    .catch(error => {
                        console.log(error.response.data || error)
                    })
            }
        }

    }
</script>

<style lang="stylus" scoped>
    div {
        padding: 1rem 4rem;
    }
</style>



// WEBPACK FOOTER //
// src/views/products/single/features/Delete.vue